import { Link } from 'react-router-dom'
import { useTranslation } from '../../i18n'
import './Hero.css'

function Hero() {
  const { t } = useTranslation()

  return (
    <section className="hero" aria-label="Hero — AI-powered interview assistant">
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">🎯</span>
            <span>{t('heroBadge')}</span>
          </div>
          
          <h1 className="hero-title">
            {t('heroTitle1')}{' '}
            <span className="gradient-text">{t('heroTitle2')}</span>
            <br />
            {t('heroTitle3')}
          </h1>
          
          <p className="hero-description">
            {t('heroDescription')}
          </p>
          
          <div className="hero-actions">
            <Link to="/download" className="btn btn-primary btn-large">
              {t('navDownload')}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </Link>
            <a href="#how-it-works" className="btn btn-secondary btn-large">
              {t('heroCtaSecondary')}
            </a>
          </div>
          
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-icon">🔒</span>
              <span className="stat-text">{t('heroStat1')}</span>
            </div>
            <div className="stat">
              <span className="stat-icon">⚡</span>
              <span className="stat-text">{t('heroStat2')}</span>
            </div>
            <div className="stat">
              <span className="stat-icon">🖥️</span>
              <span className="stat-text">{t('heroStat3')}</span>
            </div>
          </div>
        </div>
        
        <div className="hero-visual">
          <div className="hero-mockup">
            <div className="mockup-header">
              <div className="mockup-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <span className="mockup-title">{t('mockupTitle')}</span>
            </div>
            <div className="mockup-content">
              <div className="mockup-panel transcript">
                <h4>{t('mockupTranscript')}</h4>
                <div className="transcript-line">
                  <span className="speaker interviewer">{t('mockupInterviewer')}</span>
                  <span>{t('mockupQuestion')}</span>
                </div>
              </div>
              <div className="mockup-panel question">
                <h4>{t('mockupDetectedQuestion')}</h4>
                <p className="question-text">{t('mockupQuestionText')}</p>
                <span className="question-type">{t('mockupQuestionType')}</span>
              </div>
              <div className="mockup-panel hints">
                <h4>{t('mockupAiHints')}</h4>
                <div className="hint answer">
                  <span className="hint-label">💡 {t('mockupAnswer')}</span>
                  <p>{t('mockupAnswerHint')}</p>
                </div>
                <div className="hint depth">
                  <span className="hint-label">🔍 {t('mockupGoDeeper')}</span>
                  <p>{t('mockupDepthHint')}</p>
                </div>
                <div className="hint lateral">
                  <span className="hint-label">🔀 {t('mockupRelated')}</span>
                  <p>{t('mockupLateralHint')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-gradient"></div>
    </section>
  )
}

export default Hero
